import React from 'react';
import qs from 'qs';

// Data
import { HOME_ROUTE } from '../../../../../_configuration';

// Components
import SetPasswordFormContainer from '../../../User/SetPasswordForm/set-password-form.container';
import SingleFormLayout from '../../_layout/SingleFormLayout/single-form.layout';
import { ParentLoginNotice } from '../../../User/ParentLoginNotice/parent-login-notice.component';
import { SignedInRedirect } from '../../../_core/SignedInRedirect/signed-in-redirect.component';
import { SessionType } from '../../../../lib/types/session.types';

interface ResetPasswordPageProps {
  location: any;
}

export const ResetPasswordPage: React.FC<ResetPasswordPageProps> = ({ location }) => {
  const { token } = qs.parse(location.search, { ignoreQueryPrefix: true });

  return (
    <SignedInRedirect tree={SessionType.STAFF} discardsLink={Boolean(token)}>
      <SingleFormLayout maxWidth="600px">
        <SetPasswordFormContainer redirect={HOME_ROUTE} redirectAction="Sign In" token={String(token)}/>
        <ParentLoginNotice />
      </SingleFormLayout>
    </SignedInRedirect>
  );
}
